/* Pasek informacyjny - rotacja komunikatów.
   Zatrzymuje się na najechaniu i na fokusie klawiatury, więc da się kliknąć
   w link, zanim komunikat zniknie. Przy prefers-reduced-motion nie rusza sam -
   zostają strzałki. */
(() => {
  const uruchom = (bar) => {
    const items = [...bar.querySelectorAll('.ciroa-ib__item')];
    if (items.length < 2) return;

    const spokojnie = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const interwal = Number(bar.dataset.interwal) || 5000;
    let i = items.findIndex((el) => el.hasAttribute('data-aktywny'));
    if (i < 0) i = 0;
    let timer = null;

    const pokaz = (nowy) => {
      items[i].removeAttribute('data-aktywny');
      i = (nowy + items.length) % items.length;
      items[i].setAttribute('data-aktywny', '');
    };
    const start = () => {
      if (spokojnie || timer) return;
      timer = setInterval(() => pokaz(i + 1), interwal);
    };
    const stop = () => { clearInterval(timer); timer = null; };

    bar.querySelector('[data-ib-prev]')?.addEventListener('click', () => { stop(); pokaz(i - 1); start(); });
    bar.querySelector('[data-ib-next]')?.addEventListener('click', () => { stop(); pokaz(i + 1); start(); });

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));

    start();
  };

  const init = () => document.querySelectorAll('[data-ciroa-infobar]').forEach(uruchom);
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
  // po zmianie w edytorze motywu sekcja jest przerysowywana
  document.addEventListener('shopify:section:load', init);
})();
